<template>
  <div class="modal" tabindex="-1" ref="modal"  aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <slot/>
      </div>
    </div>
</div>
</template>

<script>
import bootstrap from "bootstrap/dist/js/bootstrap";

export default {
  props: ['options'],

  data(){
    return {
      modal: null
    }
  },

  methods: {
    show(){
      this.modal.show();
    },

    hide(){
      this.modal.hide();
    }
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal, {
      backdrop: 'static',
      ...this.options
    });

    this.modal._element.addEventListener('hidden.bs.modal', () => {
      this.$emit('close');
    });
  },

  destroy(){
    this.modal.dispose();
  }
}
</script>